import type {DeckInput} from '../game/types';

/** Cosmetic selection never touches the deterministic engine random stream. */
export function offlineCosmetics(deck:DeckInput,random:()=>number=Math.random):DeckInput {
  const lifeCards=deck.lifeCards.map(c=>({cardId:c.cardId,foil:false}));
  const choices=lifeCards.map((_,i)=>i);
  for(let i=0;i<Math.min(5,choices.length);i++){
    const picked=i+Math.floor(random()*(choices.length-i));
    [choices[i],choices[picked]]=[choices[picked],choices[i]];
    lifeCards[choices[i]].foil=true;
  }
  return {...deck,mpIds:[...deck.mpIds],...(deck.mpFoils?{mpFoils:[...deck.mpFoils]}:{}),lifeCards};
}
